import React from 'react';
import { useSelector } from 'react-redux';

import {
  getEditMode,
  getDivestitureDiagnosticResults,
} from '../../../../features/divestitureDiagnostic/divestitureDiagnosticSlice';
import './Subcategory.scss';
import ScoreView from '../Category/ScoreView/ScoreView';
import ScoreTextInput from '../ScoreTextInput/ScoreTextInput';
import Description from '../Category/Description/Description';
import InitialDescription from '../InitialDescription/InitialDescription';
import ComplexityScaleWrapper from '../ComplexityScaleWrapper/ComplexityScaleWrapper';

const getIsDescriptionAdjusted = (
  editableSubcategoryId,
  originalCategories
) => {
  const originalSubcategory = originalCategories.find(
    (originalCategory) => originalCategory.categoryId === editableSubcategoryId
  );
  return (
    originalSubcategory.description !== originalSubcategory.initialDescription
  );
};

const Subcategory = ({ subcategory, onScoreChange, onDescriptionChange }) => {
  const isEditMode = useSelector(getEditMode);

  const { data: originalCategories } = useSelector(
    getDivestitureDiagnosticResults
  );

  const thisCategory = originalCategories.find(
    (cat) => cat.categoryId === subcategory.categoryId
  );

  const isDescriptionAdjusted = getIsDescriptionAdjusted(
    subcategory.categoryId,
    originalCategories
  );

  return (
    <div className="subcategory-wrapper">
      <div className="subcategory-title-wrapper">
        <span className="subcategory-title">{subcategory.title}</span>
        {isEditMode && (
          <ScoreTextInput
            category={subcategory}
            onScoreChange={onScoreChange}
          />
        )}
        {!isEditMode && <ScoreView category={subcategory} />}
      </div>
      <ComplexityScaleWrapper
        initial={thisCategory.initialValue}
        modified={thisCategory.value}
      />
      <div className="description-wrapper">
        <br />
        <Description
          description={subcategory.description}
          onDescriptionChange={onDescriptionChange}
          isDescriptionEditable
        />
        {isDescriptionAdjusted && (
          <InitialDescription
            initialDescription={subcategory.initialDescription}
          />
        )}
      </div>
    </div>
  );
};

export default Subcategory;
